<template>
  <li>
    <div class="d-flex align-center">
      <v-btn
        :disabled="loadingOrganization"
        class="mt-2 d-inline-flex align-center"
        icon
        v-if="hasChildren"
        @click="handleClickParent"
      >
        <v-icon>
          {{ showChildren ? 'mdi-chevron-down' : 'mdi-chevron-right' }}
        </v-icon>
      </v-btn>

      <div :class="`${!hasChildren ? 'pl-9' : ''}`">
        <v-checkbox
          :disabled="loadingOrganization"
          class="mt-2"
          :label="organization.title_th"
          :input-value="organization.checked"
          @change="handleClickOrganization($event, organization)"
          hide-details
        ></v-checkbox>
      </div>
    </div>

    <ul
      v-show="hasChildren && showChildren"
      class="pl-6"
      style="list-style: none"
    >
      <organization-tree-item
        v-for="children in organization.children"
        :key="children.organization_uuid"
        :organization="children"
        :loadingOrganization="loadingOrganization"
        :handleSelectedOrganization="handleSelectedOrganization"
      />
    </ul>
  </li>
</template>

<script>
export default {
  name: 'OrganizationTreeItem',

  props: {
    organization: Object,
    handleSelectedOrganization: Function,
    loadingOrganization: Boolean
  },

  data() {
    return {
      showChildren: true,
      isCheckOrganization: false
    }
  },

  computed: {
    hasChildren() {
      return this.organization.children && this.organization.children.length
    }
  },

  methods: {
    handleClickParent() {
      this.showChildren = !this.showChildren
    },
    handleClickOrganization(checked, organization) {
      this.isCheckOrganization = checked

      this.setCheckOrganizationRecursive(organization)
      this.handleSelectedOrganization(organization)
    },
    setCheckOrganizationRecursive(organization) {
      organization.checked = this.isCheckOrganization

      if (organization.children && organization.children.length) {
        organization.children.forEach(children => {
          this.setCheckOrganizationRecursive(children)
        })
      }
    }
  }
}
</script>
